import BenefitManagementStore from "stores/BenefitsManagementStore";
import {Formik} from "formik";

import "./BenefitsCreateForm.scss";

import React, {useState} from "react";
import {BenefitPayload} from "models/Benefit";
import DataForm from "../BenefitForm/BenefitForm";
import {useHistory} from "react-router-dom";
import Loader from "../../commons/Loader/Loader";


const BenefitCreateForm: React.FC = () => {
  const history = useHistory();
  const [isUploading, setIsUploading] = useState<boolean>(false);

  if (isUploading) {
    return <Loader />
  }


  const handleSubmit = (values: BenefitPayload) => {
    setIsUploading(true)
    BenefitManagementStore.addBenefit(values).
    then((b) => history.push("/benefits/"+encodeURIComponent(b.id))).
    catch(() =>setIsUploading(false))
  }

  return (
    <div className="c-benefit-form">
      <Formik
        initialValues={
        {
          "price": {"value": 0},
          "id": "", "family": "", "isActive": false,
          "baseBenefit": false, "packageName": ""
        }
      }
        onSubmit={handleSubmit}
        component={DataForm}
      />
    </div>
  )
}


export default BenefitCreateForm;